// components/UsuariosSection.tsx

import { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';

import {
    DataTableColumn,
} from '@/presentation/components/common/DataTable';
import { IconButton } from '@/presentation/components/common/IconButton/IconButton';
import { useCongrupo } from '@/presentation/hooks/useCongrupo';
import { useSimple } from '@/presentation/hooks/useSimple';


import { ActionSection } from './ActionSection';
import { CreateDialog } from './CreateActionDialog';
import { DeleteActionDialog } from './DeleteActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { formatSmartDateTime } from '@/shared/utils/dateFormaters';

interface ActionItem {
    id: number;
    nombre: string;
    usuario: string;
    fecha: Date;
}

interface UsuariosSectionProps {
    IncidenteId: string;
}

export function UsuariosSection({
    IncidenteId,
}: UsuariosSectionProps) {
    const [createOpen, setCreateOpen] =
        useState(false);


    const [deleteOpen, setDeleteOpen] =
        useState(false);

    const [selectedId, setSelectedId] =
        useState<number | null>(null);

    const {
        data: usuarios,
        reload: loadUsuarios,
    } = useSimple('usuarios');

    const { remove } =
        useSimple('luc_visitas_usuarios');

    const {
        data: visitasUsuarios,
        loadByGroup,
        create,
    } = useCongrupo();

    const loadVisitasUsuarios = async () => {
        await loadByGroup(
            'luc_visitas_usuarios',
            IncidenteId
        );
    };

    useEffect(() => {
        loadVisitasUsuarios();
    }, [IncidenteId]);



    const columns: DataTableColumn<ActionItem>[] =
        [

            {
                key: 'usuario',
                header: 'Usuario',
            },
            {
                key: 'fecha',
                header: 'Asignado',
                render: (item) =>
                    formatSmartDateTime(item.fecha),
            },
            {
                key: 'eliminar',
                header: '',
                render: (item) => (
                    <IconButton
                        icon={<Trash2 size={30} />}
                        title="Eliminar"
                        color="danger"
                        onClick={() => {
                            setSelectedId(item.id);
                            setDeleteOpen(true);
                        }}
                    />
                ),
            },
        ];

    const handleOpenCreate = async () => {
        if (usuarios.length === 0) {
            await loadUsuarios();
        }

        setCreateOpen(true);
    };

    const handleCreate = async (
        values: Record<string, unknown>
    ) => {
        await create('luc_visitas_usuarios', {
            nombre: 'A',
            grupo: IncidenteId,
            usuario: values.usuario as string,
            fecha: new Date()
        });

        setCreateOpen(false);
        await loadVisitasUsuarios();
    };

    const handleDelete = async () => {
        if (selectedId === null) return;

        await remove(selectedId);

        setDeleteOpen(false);
        setSelectedId(null);

        await loadVisitasUsuarios();
    };

    return (
        <>
            <ActionSection
                title="Usuarios"
                buttonLabel="Nuevo Usuario"
                data={visitasUsuarios}
                columns={columns}
                emptyMessage="No hay usuarios cargados"
                onCreate={handleOpenCreate}
            />

            <CreateDialog
                open={createOpen}
                title="Nuevo Usuario"
                onClose={() => setCreateOpen(false)}
            >
                <Form
                    fields={[
                        {
                            name: "usuario",
                            type: "select",
                            label: "Usuario",
                            options: usuarios.map((usuario) => ({
                                value: usuario.id,
                                label: `${usuario.nombre} ${usuario.apellido}`,
                            })),
                        },
                    ]}
                    submitLabel="Agregar"
                    onSubmit={handleCreate}
                />
            </CreateDialog>

            <DeleteActionDialog
                open={deleteOpen}
                title="Eliminar usuario"
                message="¿Seguro que quiere eliminar el usuario?"
                onClose={() => setDeleteOpen(false)}
                onConfirm={handleDelete}
            />
        </>
    );
}